import { useEffect, type ReactNode } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { AuthSplash } from './AuthSplash';
import { isDevAuthBypass } from './oktaConfig';

export function RequireAuth({ children }: { readonly children: ReactNode }) {
  if (isDevAuthBypass) return <>{children}</>;
  // eslint-disable-next-line react-hooks/rules-of-hooks -- isDevAuthBypass is a build-time constant
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (!authState) return;
    if (authState.isAuthenticated) return;
    const originalUri = window.location.pathname + window.location.search + window.location.hash;
    oktaAuth.setOriginalUri(originalUri);
    void oktaAuth.signInWithRedirect();
  }, [authState, oktaAuth]);

  if (authState?.isAuthenticated) {
    return <>{children}</>;
  }

  return <AuthSplash label="Authenticating with Okta" />;
}
